import HomeIcon from '@mui/icons-material/Home'
import SearchIcon from '@mui/icons-material/Search'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'
import NotificationBadge from 'components/Page/SideMenu/NotificationBadge'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'

export const menuIcons = {
    Home: <HomeIcon />,
    MyDances: <SelfImprovementIcon />,
    MyRequests: <NotificationBadge />,
    Search: <SearchIcon />,
    allMediaRequests: <HourglassEmptyIcon />,
}

export const menuActions = {
    Home: (navigate) => navigate('/'),
    MyDances: (navigate) => navigate('/myDances'),
    MyRequests: (navigate) => navigate('/myRequests'),
    Search: (navigate) => navigate('/advancedSearch'),
    allMediaRequests: (navigate) => navigate('/allMediaRequests'),
}

export const menuItems = ['Home', 'MyDances', 'MyRequests', 'Search']
export const menuItemsSuperAdmin = [...menuItems, 'allMediaRequests']
